import React from "react";
import PropTypes from "prop-types";

// styles
import * as styles from "./TeamMemberCard.module.css";

const TeamMemberCard = ({ member, onReadBio }) => {
  const handleClick = () => {
    if (onReadBio) {
      onReadBio(member);
    }
  };

  return (
    <div className={styles.teamCard}>
      <div className={styles.cardContent}>
        <div className={styles.imageWrapper}>
          <div className={styles.profileImage}>{member.drImage}</div>
        </div>
        <button onClick={handleClick} className={styles.bioButton}>
          <span className={styles.bioLine}></span>
          <span className={styles.bioText}>Read Bio</span>
        </button>
        <div className={styles.infoSection}>
          <h4 className={styles.memberName}>{member.drName}</h4>
          <p className={styles.memberDesignation}>{member.designation}</p>
          {member.company && (
            <p className={styles.memberCompany}>{member.company}</p>
          )}
        </div>
      </div>
    </div>
  );
};

TeamMemberCard.propTypes = {
  member: PropTypes.shape({
    id: PropTypes.string,
    drName: PropTypes.string.isRequired,
    designation: PropTypes.string.isRequired,
    company: PropTypes.string,
    drImage: PropTypes.node.isRequired,
  }).isRequired,
  onReadBio: PropTypes.func,
};

export default TeamMemberCard;
